import { DynamicStandaloneAdunit } from '@/components/Adunit';
import { LabradorComponent } from '@/types/component';
import withDebugMetadata from '@/utils/withDebugMetadata';

const LabradorAdunit: LabradorComponent = ({ type, data, meta }) => {
  return <DynamicStandaloneAdunit data={data} title={'Annons'} {...withDebugMetadata({ type, meta })} />;
};

export default LabradorAdunit;
